<template>
  <VDropdown
    v-if="!isLoggedIn"
    placement="top-end"
    @apply-show="focusFormLogin"
  >
    <button
      type="menu"
      :class="{'btn btn__fitMode ': !onlyLogin, 'font-bold': onlyLogin}"
    >
      {{ $t("layout.account.login") }}
    </button>
    <template #popper>
      <Login ref="loginFormContent" />
    </template>
  </VDropdown>
</template>

<script>
import Login from '@/components/user/UserAuthLogin';

import { mapGetters } from 'vuex';

export default {
  name: 'UserAuthButtonLogin',

  components: {
    Login
  },

  props: {
    onlyLogin: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    ...mapGetters('user', ['isLoggedIn'])
  },

  methods: {
    focusFormLogin() {
      this.$refs.loginFormContent.focusFirstElement();
    }
  }
};
</script>
